export default __webpack_public_path__ + "static/media/dfinity-logo-dark-mode.833a5708.png";